/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MySettlementsResponseDto } from '../../models/my-settlements-response-dto';

export interface SettlementControllerSearchMySettlements$Params {

/**
 * 페이지 번호
 */
  pageNo?: string;

/**
 * 페이지 크기
 */
  pageSize?: string;

/**
 * 시작 날짜 (YYYY-MM-DD)
 */
  startDate?: string;

/**
 * 종료 날짜 (YYYY-MM-DD)
 */
  endDate?: string;
}

export function settlementControllerSearchMySettlements(http: HttpClient, rootUrl: string, params?: SettlementControllerSearchMySettlements$Params, context?: HttpContext): Observable<StrictHttpResponse<MySettlementsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerSearchMySettlements.PATH, 'get');
  if (params) {
    rb.query('pageNo', params.pageNo, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MySettlementsResponseDto>;
    })
  );
}

settlementControllerSearchMySettlements.PATH = '/api/settlement/me';
